module.exports = __webpack_public_path__ + "img/resultado1.9ef3ce26.jpg";